import { render, staticRenderFns } from "./ArchievedRequests.vue?vue&type=template&id=3afec78c&"
import script from "./ArchievedRequests.vue?vue&type=script&lang=js&"
export * from "./ArchievedRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports